<template>
  <program-plans-updater
    :item-id="itemId"
    :item-type="itemType"
    :existing-item="existingItem"
    :validated-item="validatedItem">
    <page-view
      :id="`create-${itemType}-view`"
      slot-scope="{ updateProgramPlans }">
      <sixteen-wide-column>
        <back-button/>
        <h1 class="ui dividing header">
          {{ $t(`${itemType}s.edit`) }}
        </h1>
      </sixteen-wide-column>

      <template v-if="existingItem">
        <component
          :ref="`${itemType}Form`"
          :is="itemForm"
          :existing-item="existingItem"
          @validated-item="setValidatedItem"/>

        <div class="field">
          <button
            @click="submitItem(updateProgramPlans)"
            class="ui primary button">
            {{ $t(`${itemType}Form.update`) }}
          </button>
        </div>
      </template>
    </page-view>
  </program-plans-updater>
</template>

<script>
import BackButton from '../components/menu/BackButton'
import SixteenWideColumn from '../components/utility/SixteenWideColumn'
import { APIError } from '../helpers'
import { ProgramPlansUpdater } from '../renderless'
import { Lesson, Action } from '../structs/structs'

const structs = new Map(
  [
    ['program-lesson', Lesson],
    ['program-action', Action]
  ]
)

export default {
  name: 'ItemEdit',
  components: { ProgramPlansUpdater, SixteenWideColumn, BackButton },
  props: {
    itemType: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    itemForm: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      existingItem: null,
      validatedItem: null
    }
  },
  created () {
    this.getItem()
  },
  methods: {
    getItem () {
      let requestUrl = process.env.VUE_APP_PROGRAM_URL + '/programPlans/' + this.itemId

      this.$axios.get(
        requestUrl,
        this.requestConfig
      ).then(
        ({ data }) => {
          this.existingItem = new (structs.get(`program-${this.itemType}`))(data.result)
        }
      )
    },
    updateItem (updateProgramPlans) {
      let requestUrl = process.env.VUE_APP_PROGRAM_URL + '/programPlan'

      this.validatedItem.data.lastModifiedByUser = this.$store.state.userEmail
      this.validatedItem.data.lastModifiedTime = Date.now()

      this.$axios.put(
        requestUrl,
        this.validatedItem,
        this.requestConfig
      ).then(
        ({ data }) => {
          return updateProgramPlans()
        },
        ({ response }) => {
          return new Promise(
            (resolve, reject) => {
              reject(new APIError(`Error updating ${this.itemType}`, response))
            }
          )
        }
      ).catch(
        error => {
          this.$rollbar.error(error.message, error.response)
        }
      ).then(
        outcomes => {
          return new Promise(
            (resolve, reject) => {
              let rejections = outcomes.filter(({ status }) => status === 'rejected')

              rejections.length
                ? reject(rejections)
                : resolve()
            }
          )
        }
      ).catch(
        errors => {
          this.$rollbar.error('Error in updating one or many program plans', errors)
        }
      ).finally(
        () => {
          this.$router.push({ name: `${this.titleCase(this.itemType)}s` })
        }
      )
    },
    validateItem () {
      this.$refs[`${this.itemType}Form`].validateForm()
    },
    setValidatedItem (item) {
      this.$set(this, 'validatedItem', item)
    },
    submitItem (updateProgramPlans) {
      this.validatedItem ? this.updateItem(updateProgramPlans) : this.validateItem()
    }
  }
}
</script>

<style scoped>

</style>
